import { ITheme, theme } from "../../utils/theme";


export const buttonContainerStyle = {
  display: "flex",
  justifyContent: "center",
  mt: 5,
  mb: 5,
  gap: 6,
};

export const inputStyle = {
  minHeight: "5rem",
};

export const asteriskStyle = {
  color: (theme: ITheme) => theme.palette.red.A700,
};

export const addressFieldStyle = {
  pl: 4,
  pr: 4,
}

export const messageStyle = (theme: ITheme) => ({
  color: theme.palette.red["850"],
  background: theme.palette.red["350"],
  padding: 4,
});

export const provideEmailBoxStyle = {
  pl: 2,
  pt: 2,
  pb: 2,
  mt: 2,
  mb: 2,
  ml: 2,
};

export const provideEmailTextStyle = {
  fontWeight: "bold",
  color: "primary.main",
  mb: 1,
};

export const emailReceivedBoxStyle = {
  ml: 2,
  mb: 2,
};

export const emailReceivedTextStyle = {
  fontWeight: "bold",
  color: "primary.main",
  pt: 2,
  pb: 1,
};

export const addressListBoxStyle = {
  display: 'flex',
  justifyContent: 'none',
  alignItems: 'left',
  padding: '8px 0',
  borderTop: '1px solid ' + theme.palette.grey[600],
  background: theme.palette.grey[500],
  margin: '1px 2px -8px 6px'
};

export const addressListBoxFooterStyle = {
  fontSize: 12,
  color: theme.palette.grey.A700,
  marginLeft: 2, marginTop: 3
};